<template>
	<div 
		class="sheet-view-tab" :class="{ selected }"
		:data-query-selector="`sheet-view-tab-${sheetView.$internals.metaProperties.meta.guid}`"
	>
		<div class="icon-wrapper">
			<router-link
				@click.native="_event_onNavigate"
				event=""
				class="icon-wrapper"
				:to="navRoute">
				<div class="icon-wrapper">
					<p-icon overrideColor :icon="sheetViewIcon" />
				</div>
			</router-link>
		</div>
		<router-link
			class="label"
			:class="{
				wider: !workbookHasPermission('sheet_addNew'),
			}"
			@click.native="_event_onNavigate"
			:to="navRoute"
			event="">
			{{ sheetView.title }}
		</router-link>
		<div
			v-if="!!sheetViewExplainer
				&& permissions.canEditSheetName"
			class="icon-wrapper">
			<explainer-pop
				:explainerKey="sheetViewExplainer"
				:sheetView="sheetView">
				<div class="icon-wrapper">
					<p-icon overrideColor icon="help" />
				</div>
			</explainer-pop>
		</div>
		<div
			v-if="hasAnyPermission"
			:class="`icon-wrapper click ${isMenuOpen ? 'highlight' : ''}`"
			@click="openMenu">
			<p-icon overrideColor icon="caret-down" />
		</div>
	</div>
</template>
<script type="text/javascript">
import SheetViewTypes from 'js/sheet-view/sheet-view-types';
import ExplainerPop from 'vue/education/explainer-bubble/explainer-pop';
import MenuItemTip from "vue/app-structure/navbar/navbar-menuitem-tip.vue";

export default {
	$contextMenu: {
		onMenuLaunched(menuDetails) {
			this.isMenuOpen = true;
		},
		onMenuClosed() {
			this.isMenuOpen = false;
		},
		getMenu() {
			const vcSelf = this;
			return [{
				type: MenuItemTip,
				label: "Duplicate View",
				props: {
					iconLeft: "copy",
					disabled: !this.permissions.canAddNewSheet,
					tipText: !this.permissions.canAddNewSheet
						? "You don't have permission to add a new sheet"
						: ""
				},
				events: {
					onClick(menuHandler, clickEvent) {
						// Close the menu
						menuHandler.closeRootMenu();
						vcSelf.duplicateSheetView();
					}
				}
			}, {
				type: "divider",
				props: {
					strokeSize: "thin"
				},
			}, {
				type: MenuItemTip,
				label: "Edit View Name",
				props: {
					iconLeft: "rename",
					disabled: !this.permissions.canEditSheetName,
					tipText: !this.permissions.canEditSheetName
						? "You don't have permission to edit sheet name"
						: ""
				},
				events: {
					onClick(menuHandler, clickEvent) {
						// Close the menu
						menuHandler.closeRootMenu();
						vcSelf.renameSheetView();
					}
				}
			}, {
				type: MenuItemTip,
				label: "Delete View",
				props: {
					iconLeft: "trash",
					disabled: !this.permissions.canAddNewSheet,
					tipText: !this.permissions.canAddNewSheet
						? "You don't have permission to add a new sheet"
						: ""
				},
				events: {
					onClick(menuHandler, clickEvent) {
						// Close the menu
						menuHandler.closeRootMenu();
						vcSelf.deleteSheetView();
					}
				}
			}]
		}
	},
	$pubsub: {
		sheetViews: {

		},
		workbookState: {
			subscriptions: {
				stateChanged(workbookState) {
					this.currentWorkbookState = workbookState;
				}
			}
		},
	},
	components: {
		ExplainerPop,
	},
	inject: ['workbookHasPermission'],
	props: {
		sheetViewGroupIndex: {
			required: true,
			type: Number,
		},
		sheetViewIndex: {
			required: true,
			type: Number,
		},
		sheetView: {
			required: true,
			type: Object,
		},
		selectedSheetViewGUID: {
			required: true,
		}
	},
	mounted() {
		if (this.sheetViewGroupIndex === 0 && this.sheetViewIndex === 0) {
			this.$pubsub.modules.sheetViews.pub('firstSheetViewMounted', {
				sheetView: this.sheetView,
			});
		}
	},
	data() {
		return {
			currentWorkbookState: null,
			isMenuOpen: false,
		};
	},
	watch: {
		isFirstSheet: {
			immediate: false,
			handler(isFirst) {
				if (isFirst) {
					this.$pubsub.modules.sheetViews.pub('firstSheetViewChanged', {
						sheetView: this.sheetView,
					});
				}
			}
		}
	},
	computed: {
		sheetViewExplainer() {
			return {
				timeline: "timelineIntro"
			}[this.sheetView.type];
		},
		permissions() {
			return {
				canAddNewSheet: this.sheetView.sheetViewGroup.dataStore.hasPermission("sheet_addNew"),
				canEditSheetName: this.sheetView.sheetViewGroup.dataStore.hasPermission("sheet_editName"),
				canDuplicateSheet: this.sheetView.sheetViewGroup.dataStore.hasPermission("sheet_addNew")
			};
		},
		hasAnyPermission() {
			return Object.values(this.permissions).reduce(function isTrue(returnValue, currentValue) {
				return currentValue ? true : returnValue;
			}, false);
		},
		dataStore() {
			return this.sheetView.sheetViewGroup.dataStore;
		},
		dataStoreGUID() {
			return this.dataStore.$internals.metaProperties.meta.guid;
		},
		sheetViewIcon() {
			let legacyIcon = "sheetViewTable";
			if (SheetViewTypes.types[this.sheetView.type]) {
				legacyIcon = SheetViewTypes.types[this.sheetView.type].icon;
			}
			return {
				"sheetViewTable": "table",
				"sheetViewGantt": "gantt",
				"sheetViewTimeline": "timeline"
			}[legacyIcon] || "table";
		},
		sheetViewType() {
			return this.sheetView.type;
		},
		selected() {
			return this.selectedSheetViewGUID === this.sheetView.$internals.metaProperties.meta.guid;
		},
		isFirstSheet() {
			return this.sheetViewGroupIndex === 0 && this.sheetViewIndex === 0;
		},
		isOnlyRemainingSheetView() {
			if (this.sheetView.sheetViewGroup.dataStore.sheetViewGroups.length > 1) {
				return false;
			} else if (this.sheetView.sheetViewGroup.sheetViews.length > 1) {
				return false;
			}
			return true;
		},
		navRoute() {
			return `/sheets/${this.dataStoreGUID}/${this.sheetView.$internals.metaProperties.meta.guid}`;
		}
	},
	methods: {
		_event_onNavigate(mouseEvent) {
			if (!this.selected) { // If we are selected, there's no point in navigating!
				this.$pubsub.modules.actions.pub("execute", {
					actionName: "changeSheetView",
					description: "Change Sheet View",
					parameters: [this.sheetView.$internals.metaProperties.meta.guid]
				});
			}
		},
		duplicateSheetView() {
			const vcSelf = this;
			const lm = this.$root.systemState.licenseManager;
			lm.verifyProvisionedEntitlementAvailability("Workbook.Worksheets", 1, function withEntitlement(hasEntitlementAvailable) {
				if (hasEntitlementAvailable) {
					vcSelf.$pubsub.modules.sheetViews.pub("duplicateSheetView", { sheetView: vcSelf.sheetView });
				} else {
					vcSelf.$pubsub.modules.upgrade.pub("openModal", {
						flowName: "entitlementExhausted",
						attributes: {
							entitlementIdentifier: "Workbook.Worksheets"
						}
					});
				}
			});
		},
		renameSheetView() {
			this.$pubsub.modules.sheetViews.pub("renameSheetView", { sheetView: this.sheetView });
		},
		deleteSheetView(clickEvent) {
			this.$pubsub.modules.sheetViews.pub("deleteSheetView", { sheetView: this.sheetView });
		},
		openMenu(clickEvent) {
			// Prevent the default click from changing the page
			clickEvent.stopPropagation();
			clickEvent.preventDefault();
			// Get the root element bounding rectangle
			const { top, left, width, height } = this.$el.getBoundingClientRect();
			// Open the context menu
			this.$contextMenu.open({
				x: left + width - 10 - 26,
				y: top + 10
			});
		}
	}
}
</script>
<style scoped lang="scss">
div.sheet-view-tab {
	display: grid;
	grid-template-columns: auto 1fr auto auto;
	align-items: center;
	user-select: none;
	padding: 8px 6px;
	&.selected {
		background: $p-color-white;
	}
	.label {
		@include clickable;
		width: max-content;
		max-width: 100px;
		overflow-x: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		text-decoration: none;
		color: $p-color-grey-500;
		padding-left: 6px;
		padding-right: 6px;
	}
	div.icon-wrapper {
		display: inline-block;
		width: 20px;
		height: 20px;
		color: $p-color-grey-300;
	}
	div.click {
		@include clickable;
	}
	div.icon-wrapper + div.icon-wrapper {
		padding-left: 2px;
	}
	div.highlight {
		background: $p-color-blue-100;
	}
}
</style>